// import { createApp } from 'vue'
// import LibComponents from '../../lib/jin'
// import UIComponents from '../../src/components'

export const Core = {
  install: (app, options = {}) => {
    if (Core.installed) return
    Core.installed = true

    // Vue.prototype 대신 globalProperties 사용
    //app.config.globalProperties.$core = createApp({}).mount(document.createElement('div'))
    // solution 1: simple object
    app.config.globalProperties.$core = {}

    // solution 2: reactive object
    // import { createApp, reactive } from 'vue'
    // app.config.globalProperties.$core = reactive({})

    // 컴포넌트 등록 함수
    const registerComponents = (components) => {
      if (components) {
        for (const key in components) {
          const component = components[key]
          app.component(key, component)
        }
        return true
      }
      return false
    }

    // 전달된 컴포넌트들 등록
    registerComponents(options.components)
  },
  version: 'core-3.0.1',
}